// extracted by mini-css-extract-plugin
export default {"tabs":"Amy4MHbKQW7CvxcxUky7"};